import { ArrowLeftIcon, ArrowRightStartOnRectangleIcon } from '@heroicons/react/20/solid';
import axios from 'axios';
import { type FormEvent, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import auth from '@/helpers/auth';

const RefreshSessionPage = function () {
    const navigate = useNavigate();
    const [
        t,
    ] = useTranslation('pages');

    const [
        code,
        setCode,
    ] = useState('');

    const confirm = async () => {
        await axios.post(`/api/auth/2fa/refresh`, {
            code: code,
        }).then(({ data }) => {
            auth.setUser(data);

            navigate(auth.getInitialPath());
        }).catch(() => {
            // Swal.fire({
            //     title: 'Error!',
            //     text: `Refresh failed.`,
            //     icon: 'error',
            //     confirmButtonText: 'OK, I\'ll try again',
            // });
        });

        return false;
    };

    return (
        <div className='max-w-md'>
            <h2 className='mt-6 text-center text-3xl font-bold tracking-tight text-foreground'>
                {t('Refresh your session')}
            </h2>
            <form className='mt-8 space-y-6' onSubmit={ (e: FormEvent) => {
                e.preventDefault();

                return confirm();
            } }>
                <input defaultValue='true' name='remember' type='hidden' />
                <div className='-space-y-px rounded-md shadow-sm'>
                    <div>
                        <label className='sr-only' htmlFor='code'>
                            {t('Code')}
                        </label>
                        <input
                            className='relative block w-full appearance-none rounded-md border border-input px-3 py-2 text-foreground placeholder-muted-foreground focus:z-10 focus:border-primary focus:outline-none focus:ring-primary sm:text-sm'
                            id='code'
                            name='code'
                            onChange={ (e) => {
                                return setCode(e.target.value);
                            } }
                            placeholder={ t('Authentication code') }
                            required
                            type='code'
                            value={ code }
                        />
                    </div>
                </div>

                <div className='flex flex-col space-y-2'>
                    <button
                        className='group inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0 bg-primary text-primary-foreground hover:bg-primary/90 h-10 px-4 py-2 btn-primary w-full'
                        type='submit'
                    >
                        <ArrowRightStartOnRectangleIcon aria-hidden='true' className='h-5 w-5' />
                        {t('Confirm login')}
                    </button>
                    <button
                        className='group flex w-full justify-center rounded-md border border-primary bg-background py-2 px-4 text-sm font-medium text-primary hover:text-success hover:border-success focus:outline-none focus:ring-2 focus:ring-success focus:ring-offset-2'
                        onClick={ () => {
                            return navigate('/login');
                        } }
                        type='button'
                    >
                        <ArrowLeftIcon aria-hidden='true' className='h-5 w-5' />
                        {t('Go to login')}
                    </button>
                </div>
            </form>
        </div>
    );
};

export default RefreshSessionPage;
